var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", "max-width": "820px" },
      on: { "click:outside": _vm.closeModal },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "d-flex align-center" },
            [
              _c("v-icon", { attrs: { color: "warning" } }, [
                _vm._v("mdi-alert"),
              ]),
              _c("span", { staticClass: "pl-2" }, [
                _vm._v("Rule Deviations"),
                _vm.storeName
                  ? _c("span", [_vm._v(" — " + _vm._s(_vm.storeName))])
                  : _vm._e(),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.closeModal } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c("v-card-subtitle", { staticClass: "pt-2 pb-1" }, [
            _vm._v(
              " These rules aren't on every store in the group, so they're hidden from the group view. Use a row's actions to sync the rule to the stores missing it, or disable it on every store that has it. "
            ),
          ]),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.deviations,
              "items-per-page": -1,
              dense: "",
              "hide-default-footer": "",
              loading: _vm.loading,
              "loading-text": "Updating store rules…",
              "no-data-text":
                "No rule deviations — every store shares the same rules.",
            },
            scopedSlots: _vm._u([
              {
                key: "item.rule",
                fn: function ({ item }) {
                  return [
                    _c("td", { staticClass: "py-2" }, [
                      _c(
                        "div",
                        { staticClass: "font-weight-medium" },
                        [
                          _vm._v(
                            " " + _vm._s(item.rep.rule_display_name) + " "
                          ),
                          item.rep.enabled === false
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ml-1",
                                  attrs: {
                                    "x-small": "",
                                    color: "grey",
                                    "text-color": "white",
                                  },
                                },
                                [_vm._v("Disabled")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.deviationCaption(item.rep)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "text-caption grey--text text--darken-1",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.deviationCaption(item.rep)) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "item.present",
                fn: function ({ item }) {
                  return [
                    _c(
                      "td",
                      { staticClass: "py-2" },
                      [
                        _c(
                          "v-chip",
                          {
                            staticClass: "mr-2 font-weight-bold",
                            attrs: {
                              "x-small": "",
                              color: "success",
                              "text-color": "white",
                            },
                          },
                          [_vm._v(" " + _vm._s(item.present.length) + " ")]
                        ),
                        _c("span", { staticClass: "text-caption" }, [
                          _vm._v(_vm._s(item.present.join(", "))),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.missing",
                fn: function ({ item }) {
                  return [
                    _c(
                      "td",
                      { staticClass: "py-2" },
                      [
                        _c(
                          "v-chip",
                          {
                            staticClass: "mr-2 font-weight-bold",
                            attrs: {
                              "x-small": "",
                              color: "error",
                              "text-color": "white",
                            },
                          },
                          [_vm._v(" " + _vm._s(item.missing.length) + " ")]
                        ),
                        _c("span", { staticClass: "text-caption" }, [
                          _vm._v(_vm._s(item.missing.join(", "))),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function ({ item }) {
                  return [
                    _c(
                      "td",
                      { staticClass: "text-end" },
                      [
                        _c(
                          "v-menu",
                          {
                            attrs: { "offset-y": "", left: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: {
                                              icon: "",
                                              small: "",
                                              disabled: _vm.loading,
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-dots-vertical"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("apply-to-all", item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "success" } },
                                          [_vm._v("mdi-store-plus")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-list-item-title", [
                                      _vm._v(
                                        "Add to " +
                                          _vm._s(item.missing.length) +
                                          " missing store" +
                                          _vm._s(
                                            item.missing.length === 1 ? "" : "s"
                                          )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                item.rep.enabled !== false
                                  ? _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            _vm.disableTarget = item
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-icon",
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-cancel"),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c("v-list-item-title", [
                                          _vm._v("Disable on all stores"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "v-dialog",
            {
              attrs: {
                value: !!_vm.disableTarget,
                persistent: "",
                "max-width": "460",
              },
              on: {
                "click:outside": function ($event) {
                  _vm.disableTarget = null
                },
              },
            },
            [
              _vm.disableTarget
                ? _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "main white--text pa-2" },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { color: "white" } },
                            [_vm._v("mdi-cancel")]
                          ),
                          _vm._v(" Disable rule on the group? "),
                        ],
                        1
                      ),
                      _c("v-card-text", { staticClass: "pa-4" }, [
                        _vm._v(" This disables "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.disableTarget.rep.rule_display_name)
                          ),
                        ]),
                        _vm._v(
                          " on the " +
                            _vm._s(_vm.disableTarget.present.length) +
                            " store" +
                            _vm._s(
                              _vm.disableTarget.present.length === 1 ? "" : "s"
                            ) +
                            " that currently have it: "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.disableTarget.present.join(", "))),
                        ]),
                        _vm._v(
                          ". You can re-enable it from Show disabled rules. "
                        ),
                      ]),
                      _c(
                        "v-card-actions",
                        { staticClass: "pa-3 pt-0" },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.disableTarget = null
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: { click: _vm.confirmDisable },
                            },
                            [_vm._v("Disable")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }